import React from 'react'
import classNames from 'classnames'
import styles from './style.module.css'

const Button = ({
  children,
  onClick,
  color,
  disabled = false,
  style = {},
  ...props
}) => {

  const colors = {
    default: styles.default,
    white: styles.white,
    dark: styles.dark,
    green: styles.green,
    blueDark: styles.blueDark
  }

  // Se a cor for um código hexadecimal, usar como background-color inline
  const isHexColor = color && typeof color === 'string' && color.startsWith('#')
  // Se a cor for uma CSS var(), usar inline também
  const isCssVar = color && typeof color === 'string' && color.trim().startsWith('var(')
  const useInline = isHexColor || isCssVar
  const buttonStyle = useInline
    ? { ...style, backgroundColor: color, color: 'white' }
    : style

  return (
    <button 
      onClick={disabled ? undefined : onClick} 
      disabled={disabled}
      className={classNames([
        styles.btn, !useInline && colors[color]
      ])}
      style={buttonStyle}
      {...props}
    >
      {children}
    </button>
  )
}

export default Button
